/// <amd-module name="Feed/Legacy/Actions/FeedSettings/SaveUpstreamSourcesHandler" />
import { announce } from "VSS/Core/Util/Accessibility";
import * as Utils_String from "VSS/Core/Util/String";

import { Feed, UpstreamSource } from "Feed/Common/Contracts/Feed";
import * as PackageResources from "Feed/Common/Resources";
import { IFeedSettingsState } from "Feed/Legacy/Components/Settings/IFeedSettingsState";
import { IFeedDataService } from "Feed/Legacy/DataServices/FeedsDataService";

export class SaveUpstreamSourcesHandler {
    public static async deleteAsync(state: IFeedSettingsState): Promise<void> {
        // clone the objects in upstreamSources because we're going to modify one or more of them
        const sourcesClone = state.feed().upstreamSources.map(s => ({ ...s } as UpstreamSource));
        const idsToDelete: string[] = state.selectedUpstreamSources.map(s => s.id);

        sourcesClone
            .filter(source => !source.deletedDate && idsToDelete.indexOf(source.id) !== -1)
            .forEach(source => {
                source.deletedDate = new Date();
            });

        await this.save(state, sourcesClone);

        const upstreamNames = state.selectedUpstreamSources.map(s => s.name).join(", ");
        announce(Utils_String.format(PackageResources.DeletedAnnouncement, upstreamNames));

        state.selectedUpstreamSources = [];
    }

    public static async addAsync(state: IFeedSettingsState, newUpstreamSources: UpstreamSource[]): Promise<void> {
        const allSources = state.feed().upstreamSources.concat(newUpstreamSources);

        await this.save(state, allSources);
    }

    public static async reorderSourcesAsync(
        state: IFeedSettingsState,
        sourceA: UpstreamSource,
        sourceB: UpstreamSource
    ): Promise<void> {
        const sourcesClone = state.feed().upstreamSources.concat([]);
        const indexA = sourcesClone.findIndex(s => s.id === sourceA.id);
        const indexB = sourcesClone.findIndex(s => s.id === sourceB.id);

        sourcesClone[indexA] = sourceB;
        sourcesClone[indexB] = sourceA;

        await this.save(state, sourcesClone);
    }

    private static async save(state: IFeedSettingsState, sources: UpstreamSource[]): Promise<void> {
        const feed = state.feed();
        const feedPatch = {
            id: feed.id,
            upstreamSources: sources.filter(s => !s.deletedDate), // important to exclude deleted sources
            upstreamEnabled: true,
            project: feed.project
        } as Feed;

        const feedDataService = state.pageContext.getService<IFeedDataService>("IFeedDataService");
        const updatedFeed: Feed = await feedDataService.updateFeedAsync(feedPatch);

        state.feed().upstreamSources = updatedFeed.upstreamSources;

        announce(PackageResources.SavedAnnouncement);
    }
}
